export const P0003607HysteresisValues = [
  { ref: 10, label: '10 mV' },
  { ref: 20, label: '20 mV' },
  { ref: 30, label: '30 mV' },
  { ref: 40, label: '40 mV' },
  { ref: 50, label: '50 mV' },
];
